<template>
  <div class='box'>
    <!-- Header -->
    <div class="tags has-addons">
      <span class="tag" :class='!this.showBoss ? "is-dark" : "" ' style='width: 125px; cursor: pointer' v-on:click='switchSection(false)'>Colaborador</span>
      <span class="tag" :class='this.showBoss ? "is-dark" : "" ' style='width: 125px; cursor: pointer' v-on:click='switchSection(true)'>Líder</span>
    </div>

    <!-- Content -->
    <div class='contentMessages'>
      <!-- Collaborator -->
      <div v-if='!showBoss' style='width: 100%; margin-right: 10px'>
        <input v-model='data.colaborador.title' :class='errors.colaborador.title.type' style='margin-right: 5px;' class="input" type="text" placeholder="Título principal" name='titleCo' id='titleCo'>
        <span v-if='errors.colaborador.title.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.colaborador.title.message}}</span>
        <br><br>
        <textarea v-model='data.colaborador.cuerpo' :class='errors.colaborador.cuerpo.type' class="textarea textareaSettings" placeholder="Cuerpo del mensaje" rows="13" name='cuerpoCo' id='cuerpoCo'></textarea>
        <span v-if='errors.colaborador.cuerpo.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.colaborador.cuerpo.message}}</span>
      </div>
      <div v-if='!showBoss' style='width: 100%; margin-left: 10px'>
        <article class="message is-dark" style='height: 100%'>
          <div class="message-body" style='height: 100%'>
            <h1 class='is-size-3'>{{ dataDefault.title.colaboradores }}</h1>
            <h2 class="is-size-5">
              Aquí vas a evaluar a {{ tokenUser.name }}
            </h2>
            <br>
            <p style="white-space: pre-line">
              {{ dataDefault.welcome.colaboradores.Colaborador }}
            </p>
            <br>
            <span class="tag is-info">Mensaje por defecto</span>
          </div>
        </article>
      </div>
      <!-- Leader -->
      <div v-if='showBoss' style='width: 100%; margin-right: 10px'>
        <input v-model='data.lider.title' :class='errors.lider.title.type' style='margin-right: 5px;' class="input" type="text" placeholder="Titulo principal" name='titleBoss' id='titleBoss'>
        <span v-if='errors.lider.title.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.lider.title.message}}</span>
        <br><br>
        <textarea v-model='data.lider.cuerpo' :class='errors.lider.cuerpo.type' class="textarea textareaSettings" placeholder="Cuerpo del mensaje" rows="13" name='cuerpoBoss' id='cuerpoBoss'></textarea>
        <span v-if='errors.lider.cuerpo.message' class='is-size-7 has-text-danger' style='margin-top: -5px'>{{errors.lider.cuerpo.message}}</span>
      </div>
      <div v-if='showBoss' style='width: 100%; margin-left: 10px'>
        <article class="message is-dark" style='height: 100%'>
          <div class="message-body" style='height: 100%'>
            <h1 class='is-size-3'>{{ dataDefault.title.lider }} {{ tokenUser.name }}</h1>
            <br>
            <p style="white-space: pre-line">
              {{ dataDefault.welcome.lider.Lider }}
            </p>
            <br>
            <span class="tag is-info">Mensaje por defecto</span>
          </div>
        </article>
      </div>
    </div>

    <!-- Footer -->
    <div class='buttons' style='margin-top: 10px'>
      <a class="button is-danger" v-on:click='deleteMessage()'>Eliminar</a>
      <button class="button is-dark" :class='loading ? "is-loading" : ""' v-on:click='saveData'>Guardar</button>
    </div>
  </div>
</template>
<script>
import apiServices from "@/services/yungol-services";
import json from '../infoEncuesta.json'
export default {
  data(){
    return {
      showBoss: false,
      errors: {
        lider:{
          title: {},
          cuerpo: {}
        },
        colaborador:{
          title: {},
          cuerpo: {}
        }
      },
      dataDefault: json,
      loading: false
    }
  },
  props:{
    proceso: Object,
    data: Object,
    tokenUser: Object
  },
  methods:{
    switchSection(d){
      this.showBoss = d
      this.clearErrors()
    },
    async saveData() {
      if (this.validateForm()) {
          try {
            this.loading = true
            const result = await apiServices.post(`createinfo/${this.proceso._id}`, this.data);

            if (result.data){
              await this.$swal({
                text: 'Se guardo correctamente el mensaje.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
              this.loading = false
              this.clearErrors()
            }
          } catch (error) {
            console.log(error)
            await this.$swal({
              text: 'Error al guardar el mensaje.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            this.loading = false
            this.clearErrors()
          }
        }
    },
    async deleteMessage() {
      const config = {
        title: '¿Estás seguro?',
        text: "Al eliminar no se podrá recuperar el mensaje personalizado.",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#de5b5b',
        confirmButtonText: 'Sí, eliminar'
      };
      await this.$swal(config).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.clearErrors()
            const data = {
              lider:{
                lider: {
                  title: "",
                  cuerpo: ""
                }
              },
              colaborador:{
                colaborador: {
                  title: "",
                  cuerpo: ""
                }
              }
            }
            const type = this.showBoss ? 'lider' : 'colaborador'
            const resultData = await apiServices.post(`createinfo/${this.proceso._id}`, data[type]);
            if (resultData) {
              this.$emit('getData')
              await this.$swal({
                text: 'Mensaje personalizado eliminado correctamente.',
                icon: 'success',
                showConfirmButton: false,
                timer: 1700
              })
            }
          } catch (err) {
            await this.$swal({
              text: 'Error al eliminar el mensaje personalizado.',
              icon: 'error',
              showConfirmButton: false,
              timer: 1700
            })
            console.log(err)
          }
        }
      });
    },
    validateForm(){
      this.errors = {
        lider:{
          title: {},
          cuerpo: {}
        },
        colaborador:{
          title: {},
          cuerpo: {}
        }
      }

      const data = this.data
      const type = this.showBoss ? 'lider' : 'colaborador'
      let valid = true

      if (data[type].title.trim() === '' || data[type].title === null || data[type].title === undefined){
        this.errors[type].title.type = 'is-danger'
        this.errors[type].title.message = 'El titulo es requerido.'
        valid = false
      }

      if (data[type].cuerpo.trim()  === '' || data[type].cuerpo === null || data[type].cuerpo === undefined){
        this.errors[type].cuerpo.type = 'is-danger'
        this.errors[type].cuerpo.message = 'El cuerpo es requerido.'
        valid = false
      }

      return valid
    },
    clearErrors(){
      this.errors = {
        lider:{
          title: {},
          cuerpo: {}
        },
        colaborador:{
          title: {},
          cuerpo: {}
        }
      }
    }
  }
}
</script>
<style lang='scss'>
.contentMessages {
  @media screen and (min-width: 1024px) {
    display: flex;
    justify-content: space-between
  }
}
.message {
  @media screen and (max-width: 1024px){
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/Ajustes/MessageSurvey.vue